/**
 * Per-site memory of the last schedule the user looked at.
 *
 * The sidebar links to the bare `/scheduler/:siteId` (no schedule number), and
 * the page otherwise falls back to the most-recently-updated schedule — so
 * leaving and returning would silently switch which schedule you see. Persisting
 * the last-viewed number per site lets the page restore it instead.
 *
 * Browser-local (localStorage), keyed by siteId. All access is wrapped so a
 * disabled/quota-exhausted store (private mode, SSR) degrades to "no memory"
 * rather than throwing.
 */
const KEY_PREFIX = 'dorca.scheduler.lastSchedule.';

export function readLastViewedSchedule(siteId: string): string | null {
  if (!siteId) return null;
  try {
    return localStorage.getItem(KEY_PREFIX + siteId);
  } catch {
    return null;
  }
}

export function writeLastViewedSchedule(siteId: string, scheduleNumber: string): void {
  if (!siteId || !scheduleNumber) return;
  try {
    localStorage.setItem(KEY_PREFIX + siteId, scheduleNumber);
  } catch {
    // Storage unavailable or full — last-viewed memory is best-effort.
  }
}
